import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiQuote } = FiIcons;

const REVIEWS = [
  {
    quote: "Alpha Training Consultancy completely transformed our onboarding process. Their safety induction for our foreign construction workers was thorough, practical, and highly engaging.",
    author: "James Tan",
    role: "Project Director, BuildCore Construction",
    img: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379715/10_d4rxvs.png" // Using certification achievement image abstractly
  },
  {
    quote: "The Settling-In Programme provided by Alpha gave my domestic worker the confidence and knowledge she needed to start working safely and effectively in our home.",
    author: "Sarah Lim",
    role: "Employer",
    img: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379672/9_kgrbxe.png" // Multicultural workforce abstract
  }
];

const Testimonials = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-alpha-navy">Trusted by Employers & Agencies</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {REVIEWS.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-alpha-grayLight p-10 rounded-2xl relative"
            >
              <SafeIcon icon={FiQuote} className="text-6xl text-alpha-green/20 absolute top-6 right-8" />
              <p className="text-lg text-alpha-grayDark italic mb-8 relative z-10">"{review.quote}"</p>
              
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-white shadow-sm">
                  <img src={review.img} alt={review.author} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h5 className="font-bold text-alpha-navy">{review.author}</h5>
                  <p className="text-sm text-alpha-grayDark">{review.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;